import { Box, Typography, useTheme } from '@mui/material';

import CustomImageComponent from '@/components/shared/custom/custom-image';
import PositionBox from '@/components/shared/position-box';
import { formatDateToDDMMYYYY, getAgeFromDate } from '@/helpers/datetime-helper';
import { getMasterPhotoById, getTeamImageById } from '@/helpers/images-helper';
import { getPlayerIcon } from '@/helpers/players-helper';

const JugadoresHeaderSection = ({ player }) => {
    const theme = useTheme();

    return (
        <Box
            sx={{
                backgroundColor: theme.palette.background.default,
                border: `1px solid`,
                borderColor: 'border.main',
                padding: '8px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '16px',
                borderRadius: '2px',
                width: '100%',
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <CustomImageComponent
                    src={getMasterPhotoById(player?.if?.id, 120)}
                    alt={player?.if?.nm}
                    width={80}
                    height={80}
                    priority={true}
                    style={{ borderRadius: '50%' }}
                />
            </Box>

            <Box>
                <Typography fontWeight="500" color={theme.palette.text.primary} fontSize={{ xs: 14, md: 16 }}>
                    {player?.if?.nm}
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Typography color={theme.palette.text.primary} fontSize={{ xs: 12, md: 14 }}>
                        {player?.team?.name}
                    </Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25 }}>
                    <CustomImageComponent
                        src={getTeamImageById(player?.team?.id, 36)}
                        alt={'Escudo equipo'}
                        width={24}
                        height={24}
                    />
                    <PositionBox positionId={player?.if?.pid} width={16} height={16} fontSize={8} />
                    {getPlayerIcon(player?.gs?.s, player?.gs?.sl, 16, 16)}
                </Box>
            </Box>

            <Box>
                <Typography sx={{ color: theme.palette.text.primary, fontSize: '12px' }}>
                    Edad:
                    <Typography component={'span'} sx={{ marginLeft: '4px', fontSize: '12px' }}>
                        {getAgeFromDate(player?.if?.b?.dt)}
                        <i style={{ marginLeft: '2px' }}>({formatDateToDDMMYYYY(player?.if?.b?.dt)})</i>
                    </Typography>
                </Typography>

                <Typography sx={{ color: theme.palette.text.primary, fontSize: '12px' }}>
                    Estatura: <span style={{ marginLeft: '4px' }}>{player?.if?.h}</span>
                </Typography>

                <Typography sx={{ color: theme.palette.text.primary, fontSize: '12px' }}>
                    Peso: <span style={{ marginLeft: '4px' }}>{player?.if?.w}</span>
                </Typography>
                <Typography sx={{ color: theme.palette.text.primary, fontSize: '12px' }}>
                    Nacimiento:{' '}
                    <Typography component={'span'} style={{ marginLeft: '4px', fontSize: '12px' }}>
                        {player?.if?.b?.pl} - {player?.if?.b?.c}
                    </Typography>
                </Typography>
            </Box>
        </Box>
    );
};

export default JugadoresHeaderSection;
